module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图10-1.jpg?v=0e1295c6";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图10-1.jpg
 ** module id = 54
 ** module chunks = 1 2
 **/